import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import SubfoldersIcon from '@wix/da-ds/pkg/Icons/24x24/Subfolders';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import GallectionCoverDumbo from '../../GallectionCoverDumbo/GallectionCoverDumbo';
import folderSropdownDesktopStyles from './FolderDropdownDesktop.scss';
const FolderThumb = ({ folder, hasSubfolders })=>{
    const previewProps = {
        width: 86,
        height: 48
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: folderSropdownDesktopStyles['thumb-wrapper']
    }, /*#__PURE__*/ React.createElement(GallectionCoverDumbo, _object_spread_props(_object_spread({}, previewProps), {
        gallection: folder,
        className: folderSropdownDesktopStyles['thumb']
    })), hasSubfolders && /*#__PURE__*/ React.createElement(SubfoldersIcon, {
        size: IconSize.SMALL,
        className: folderSropdownDesktopStyles['subfolders-icon']
    }));
};
FolderThumb.displayName = 'FolderThumb';
export default FolderThumb;

//# sourceMappingURL=FolderThumb.js.map